<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)" 
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }} 
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <h1 class="mb-5 is-bold">{{ $t('casas-decimais') }}</h1>
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <v-input
                        :id="generateId(1)"
                        ref="decimalPlacesInput"
                        v-model="empresa.valordecimalplaces"
                        placeholder="placeholder-preencha"
                        title="decimal-places-valor"
                        msg="minimo-numero-casas-decimais"
                        :invalid="validateCamposCasasDecimais(empresa.valordecimalplaces)"
                        :required="true"
                        tooltipLabel="info-decimal-places-valor"
                        tooltipPosition="is-top"
                        :disabled="cantEdit"
                        v-mask="['#']"
                    />
                </div>
                <div class="column is-0" v-show="false">
                    <v-input
                        :id="generateId(2)"
                        ref="urlAwsInput"
                        v-model="empresa['aws_s3_folder']"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(3)"
                        ref="qtdeDecimalPlacesInput"
                        v-model="empresa.qtdedecimalplaces"
                        placeholder="placeholder-preencha"
                        title="decimal-places-qtde"
                        msg="minimo-numero-casas-decimais"
                        :invalid="validateCamposCasasDecimais(empresa.qtdedecimalplaces)"
                        :required="true"
                        tooltipLabel="info-decimal-places-qtde"
                        tooltipPosition="is-top"
                        :disabled="cantEdit"
                        v-mask="['#']"
                    />
                </div>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <h1 class="mb-5 is-bold">{{ $t('conf-download-imagem') }}</h1>
            <div class="columns is-flex-wrap">
                <div class="column is-4">
                    <vss-select
                        :id="generateId(4)"
                        ref="tipoConexaoInput"
                        title="tipo-conexao"
                        :searchable="false"
                        :options="optionsConexao"
                        v-model="empresa.img_conexao_tipo"
                        class="no-clear"
                        tooltipLabel="info-tipo-conexao"
                        tooltipPosition="is-top"
                        :required="true"
                        :mlLabels="true"
                        :disabled="cantEdit"
                        @input="clearInputs"
                    />
                </div>
                <div class="column is-4">
                    <v-input
                        :id="generateId(5)"
                        ref="urlCatalagoInput"
                        v-model="empresa.img_host"
                        placeholder="placeholder-preencha"
                        title="url-catalogo"
                        :msg="msgInvalidUrlCatalogo"
                        :onBlurFunction="validateImgHost"
                        :required="empresa.img_conexao_tipo.id === 2 ? false : true"
                        :invalid="invalidUrl"
                        tooltipLabel="info-url-catalogo"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || empresa.img_conexao_tipo.id === 2"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        :uppercase="false"
                    />
                </div>
                <div class="column is-4">
                    <v-input
                        :id="generateId(6)"
                        ref="urlCatalagoParcialInput"
                        v-model="empresa.img_host_parcial"
                        placeholder="placeholder-preencha"
                        title="url-catalogo-parcial"
                        :msg="msgInvalidUrlCatalogo"
                        :onBlurFunction="validateImgHostParcial"
                        :invalid="invalidUrlParcial && empresa.img_conexao_tipo.id === 1"
                        tooltipLabel="info-url-catalogo-parcial"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || empresa.img_conexao_tipo.id === 0 || empresa.img_conexao_tipo.id === 2"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        :uppercase="false"
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(7)"
                        ref="ftpPortaInput"
                        v-model="empresa.img_ftp_port"
                        placeholder="placeholder-preencha"
                        title="ftp-porta"
                        msg="msg-campo-obrigatorio"
                        :invalid="validateCampos(empresa.img_ftp_port)"
                        :required="empresa.img_conexao_tipo.id === 1 || empresa.img_conexao_tipo.id === 2 ? false : true"
                        tooltipLabel="info-ftp-porta"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || empresa.img_conexao_tipo.id === 1 || empresa.img_conexao_tipo.id === 2"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        validchars="0123456789"
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(8)"
                        ref="ftpUsuarioInput"
                        v-model="empresa.img_ftp_user"
                        placeholder="placeholder-preencha"
                        title="ftp-usuario"
                        msg="msg-campo-obrigatorio"
                        :invalid="validateCampos(empresa.img_ftp_user)"
                        :required="empresa.img_conexao_tipo.id === 1 || empresa.img_conexao_tipo.id === 2 ? false : true"
                        tooltipLabel="info-ftp-usuario"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || empresa.img_conexao_tipo.id === 1 || empresa.img_conexao_tipo.id === 2"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(9)"
                        ref="ftpSenhaInput"
                        v-model="empresa.img_ftp_pwd"
                        placeholder="placeholder-preencha"
                        title="ftp-senha"
                        msg="msg-campo-obrigatorio"
                        :invalid="validateCampos(empresa.img_ftp_pwd)"
                        :required="empresa.img_conexao_tipo.id === 1 || empresa.img_conexao_tipo.id === 2 ? false : true"
                        tooltipLabel="info-ftp-senha"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || empresa.img_conexao_tipo.id === 1 || empresa.img_conexao_tipo.id === 2"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(10)"
                        ref="ftpDiretorioInput"
                        v-model="empresa.img_ftp_dir"
                        placeholder="placeholder-preencha"
                        title="ftp-diretorio"
                        msg="msg-campo-obrigatorio"
                        :invalid="validateCampos(empresa.img_ftp_dir)"
                        :required="empresa.img_conexao_tipo.id === 1 || empresa.img_conexao_tipo.id === 2 ? false : true"
                        tooltipLabel="info-ftp-diretorio"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || empresa.img_conexao_tipo.id === 1 || empresa.img_conexao_tipo.id === 2"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                    />
                </div>
            </div>
        </div>
        <div class="page-container form-columns-fit">
            <h1 class="mb-5 is-bold">{{ $t('conf-receituario-agronomico') }}</h1>
            <div class="columns is-flex-wrap">
                <div class="column is-half">
                    <v-input
                        :id="generateId(11)"
                        ref="apiUrlConexaoInput"
                        v-model="empresa.receituario_api_url"
                        :maxlength="50"
                        :title="$t('api-url-conexao')"
                        :disabled="cantEdit"
                        :uppercase="false"
                    />
                </div>
                <div class="column is-half">
                    <v-input
                        :id="generateId(12)"
                        ref="apiTokenInput"
                        v-model="empresa.receituario_api_token"
                        :maxlength="255"
                        :title="$t('api-token')"
                        :disabled="cantEdit"
                        :uppercase="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import EmpresaValidation from "@/services/validations/vendas/empresa/EmpresaParametrizacaoValidation";
import Message from "@/models/Message";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from 'vuex';

export default {
    components: {
        HideInfo
    },
    data() {
        return {
            empresaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("EMPRESA"),

            service: new EmpresaService(this.$http, this.$router),
            validation: new EmpresaValidation(this.msgs),
            msgs: [],
            cleanHide: true,

            isLoading: false,
            isSaving: false,
            permissao: false,

            empresa: {
                idempresa: this.$route.params.id,
                valordecimalplaces: null,
                qtdedecimalplaces: null,
                img_conexao_tipo: { id: 3, label: 'no-select-catalogo' },
                img_host: null,
                img_host_parcial: null,
                img_ftp_port: null,
                img_ftp_user: null,
                img_ftp_pwd: null,
                img_ftp_dir: null,
                'aws_s3_folder': `${this.$store.state.user.idClienteSovis}_${this.$route.params.id}`,
                receituario_api_url: "",
                receituario_api_token: "",
            },

            invalidUrl: false,
            invalidUrlParcial: false,
            msgInvalidUrlCatalogo: "url-catalogo-invalido",

            optionsConexao: [
                { id: 2, label: 'no-select-catalogo', },
                { id: 0, label: 'select-ftp' },
                { id: 1, label: 'select-http' }
            ],

            invalidImgCatalogo: false,
            cantEdit: false,
            listaRefsCatalogo: [ 'urlCatalagoInput', 'urlCatalagoParcialInput', 'ftpUsuarioInput', 'ftpSenhaInput', 'ftpPortaInput', 'ftpDiretorioInput' ],
            isloadingEdit: false,

            isVenda: this.$route.meta.contexto == "vendas",
            isPromotor: this.$route.meta.contexto == "promotor",
            isAgro: this.$route.meta.contexto == "agro",
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false
        },
    },
    created() {
        if (this.isVenda){
            this.permissao = this.hasPermissionAccess(
                'vendas', 
                'empresa', 
                'ven-empresa-dados-cadastrais-parametrizacao')
        }else if (this.isPromotor){
            this.permissao = this.hasPermissionAccess(
                'promotor', 
                'empresa', 
                'pro-empresa-dados-cadastrais-parametrizacao');
        }else if (this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                'agro', 
                'empresa', 
                'agro-empresa-dados-cadastrais-parametrizacao');
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'parametrizacao' },
            });
        } else {
            if(this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId){
            return this.$route.name+'-paremetrizacao-'+numberId;
        },
        async carregarDados() {
            this.isLoading = true;
            this.isloadingEdit = true;

            try {
                const { content } = await this.service.find(this.$route.params.id);

                if (content !== null) {
                    const empresaProps = [
                        'valordecimalplaces',
                        'qtdedecimalplaces',
                        'img_host',
                        'img_host_parcial',
                        'img_ftp_port',
                        'img_ftp_user',
                        'img_ftp_pwd',
                        'img_ftp_dir',
                        'receituario_api_url',
                        'receituario_api_token',
                        'img_conexao_tipo',
                    ];
                    
                    empresaProps.forEach(prop => {
                        if (content[prop] !== undefined) {
                            this.empresa[prop] = content[prop];
                        }
                    });

                    this.empresa.img_conexao_tipo = this.optionsConexao.find(e => e.id === content.img_conexao_tipo) || {};
                } else {
                    this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                }
            } catch (error) {
                console.error(error);
                this.msgs.push(new Message('error', 'msg-erro-load', true));
            } finally {
                this.runValidations(true);
                this.isLoading = false;
                this.isloadingEdit = false;
            }
        },
        runValidations(focusedOut = false) {
            if(focusedOut){
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                })
            }
            this.validateCampos();
            this.validateImgHost();
            this.validateImgHostParcial();
            this.validateCamposCasasDecimais();
        },
        save() {
            this.isLoading = true;
            this.isloadingEdit = true;
            if (this.validation.validate(this.empresa, this.$refs)) {
                let empresaTemp = Object.assign({}, this.empresa);

                /**
                 * @70731 - caso o mesmo selecione a opcao de sem catalogo
                 * vai limpar todos os campos e salvar vazio no banco de dados.
                 */
                 
                if (empresaTemp.img_conexao_tipo.id === 2) {

                    const propertiesToExclude = [
                        "img_conexao_tipo",
                        "qtdedecimalplaces",
                        "valordecimalplaces",
                        "idempresa",
                        "aws_s3_folder",
                        "receituario_api_url",
                        "receituario_api_token",
                    ];

                    Object.entries(empresaTemp).forEach((entry) => {

                        if (!propertiesToExclude.includes(entry[0])) {
                            var [ attr, _ ] = entry;
                            empresaTemp[attr] = "";

                            this.empresa[attr] = "";
                        }
                    });
                } else {
                    empresaTemp.img_host = (empresaTemp.img_host || "").toLowerCase();
                    empresaTemp.img_host_parcial = (empresaTemp.img_host_parcial || "").toLowerCase();
                }

                empresaTemp.img_conexao_tipo = this.empresa.img_conexao_tipo.id;

                this.isSaving = true;
                this.service.saveParametrizacao(empresaTemp, this.abrev)
                .then(value => {
                    if(value.status==200){
                        let msg = 'msg-edit-empresa';
                        this.msgs.push(new Message('success', msg, true));
                        this.$emit("isChanged", false);
                    } else {
                        this.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    }
                })
                .catch(e => {
                    console.error("Erro ao salvar: " + e);
                    this.msgs.push(new Message("error", "msg-erro-salvar", true));
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                    this.isloadingEdit = false;
                });
            } else{
                this.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        validateCampos(value) {
            if (value === 0) {
                return false;
            }

            if (!value && this.empresa.img_conexao_tipo.id === 0) {
                return true;
            }
            
            return false;
        },
        validateImgHost() {
            if (this.empresa.img_host) {
                this.invalidUrl = false;
            }
            if (this.empresa.img_conexao_tipo.id == 0) {
                if (!this.validateFTP(this.empresa.img_host) || !this.validateDominioURL(this.empresa.img_host)) {
                    this.invalidUrl = true;
                    this.msgInvalidUrlCatalogo = "url-catalogo-invalido";
                    return;
                }
            } else if (this.empresa.img_conexao_tipo.id == 1) {
                if (!this.validateURL(this.empresa.img_host) || !this.validateDominioURL(this.empresa.img_host)) {
                    this.invalidUrl = true;
                    this.msgInvalidUrlCatalogo = "url-catalogo-invalido";
                    return;
                }

                if (this.empresa.img_conexao_tipo.id === 1 && !Util.validateURL(this.empresa.img_host)) {
                    this.invalidUrl = true;
                    this.msgInvalidUrlCatalogo = "url-catalogo-invalido";
                    return;
                }
            }
        },
        validateImgHostParcial() {
            this.invalidUrlParcial = false;

            if (this.empresa.img_host_parcial && !this.validateURL(this.empresa.img_host_parcial)) {
                this.invalidUrlParcial = true;
                this.msgInvalidUrlCatalogo = "url-catalogo-invalido";
            }
        },
        validateCamposCasasDecimais(value) {
            if (!value || value > 8) {
                return true;
            }

            return false;
        },
        /**
         * @70731 - quando é alterado o tipo de conexao
         * e verificado se é selecionado a opcao de sem catalogo
         * caso seja, é retirado o foco dos campos de catalogo.
         */
        clearInputs(value) {
            if (value.id === 2) {
                for (var i in this.listaRefsCatalogo) {
                    this.$refs[this.listaRefsCatalogo[i]].focusedOut = false;
                }
            } else {
                this.runValidations(true);
            }
        }
    },
    watch: {
        empresa: {
            deep: true,
            handler: function() {
                if(!this.isloadingEdit){
                    this.$emit("isChanged", true);
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container{
    margin-bottom: 10px;

    .loading {
        opacity: 0.5;
        pointer-events: none;
    }

}

@media (max-width: 760px) {
    .page-container:last-child {
        margin-top: 60px;
    }
}

@media (min-width: 760px) {
    .listing-header {
        margin-bottom: 0.75rem;
    }

    .page-container:last-child {
        margin-top: 0.75rem;
    }
}
</style>